import "@honeycomb/ui/ui.css";

import { render } from "react-dom";

import { App } from "./app";

const appElement = document.getElementById("app");

render(<App />, appElement);
